<div class="row main">
  <div class="col-sm-12">
    <nb-card>
        <nb-card-header>
            <nb-icon icon="question" pack="font-awesome"></nb-icon> Ayuda
        </nb-card-header>

        <nb-card-body>
          <nb-accordion>
            <nb-accordion-item>
              <nb-accordion-item-header>
                <nb-icon icon="map" pack="font-awesome"></nb-icon> <span class="help-title">Visor</span>
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                <p>Desde el visor puede navegar por el mapa de España visualizando las parcelas agrarias pertenecientes al SIGPAC.
                  Para que las parcelas se muestren debe establecer el zoom al mínimo suficiente para no sobrecargar la aplicación.
                Si el zoom está demasiado alejado aparecerá un mensaje advirtiéndole.</p>

                <p>En la parte izquierda del mapa aparecen 3 controles. Dos son para aumentar y disminuir el zoom y el otro es para mostrar u ocultar las capas del mapa</p>
                <p>Si el usuario está logueado (ha iniciado sesión), en la parte derecha aparecerá el listado de sus parcelas guardadas pudiendo filtrarlas por Municipio y Cultivo</p>
                <p>Al seleccionar una parcela (en el mapa o en el listado) se mostrará una pequeña ventana en la parte izquierda del mapa mostrando la información correspondiente a la parcela selecionada</p>
              </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item>
              <nb-accordion-item-header>
                <nb-icon icon="list" pack="font-awesome"></nb-icon> <span class="help-title">Registros</span>
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                <p>Si el usuario está logueado (ha iniciado sesión) puede acceder al listado de registros de actividad de sus parcelas</p>
                <p>Al seleccionar un registro en el panel derecho aparecerá la información completa del mismo, pudiendo editarlo y eliminarlo</p>
              </nb-accordion-item-body>
            </nb-accordion-item>

            <nb-accordion-item>
              <nb-accordion-item-header>
                <nb-icon icon="home"></nb-icon> <span class="help-title">Mi explotación</span>
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                <p>El usuario puede visualziar la campaña activa así como iniciar una nueva campaña</p>
                <p>Desde el segundo panel el usuario puede visualizar y editar los Asesores y Maquinaria asociados a su explotación</p>
              </nb-accordion-item-body>
            </nb-accordion-item>
            <nb-accordion-item>
              <nb-accordion-item-header>
                <nb-icon icon="person-outline"></nb-icon> <span class="help-title">Inicio de sesión</span>
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                <p>La aplicación <b>Visor SIGPAC Escritorio</b> es un complemento a la aplicación móvil <b>Visor SIGPAC</b> disponible para iOS y Android</p>
                <p>Deberá haber iniciado sesión en la aplicación móvil para sincronizar sus parcelas y registros, y poder acceder a ellos desde esta aplicación de escritorio</p>
              </nb-accordion-item-body>
            </nb-accordion-item>
            <nb-accordion-item>
              <nb-accordion-item-header>
                <nb-icon icon="alert-circle-outline"></nb-icon> <span class="help-title">Informar de un problema</span>
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                <p>Puede informar de un problema en la aplicación a través de <a href="https://www.aidiapp.com/problema-en-visor-sigpac/" target="_blank">este formulario</a></p>
              </nb-accordion-item-body>
            </nb-accordion-item>
          </nb-accordion>





        </nb-card-body>
      </nb-card>
  </div>


</div>
